import Icon from 'components/Icon';
import ModalHeaderTitle from 'components/ModalHeaderTitle';

import styles from './styles.module.scss';

const ModalHeader = ({
    headerHeadingClassName,
    headerIconClassName,
    headerTextClassName,
    icon,
    iconAlt = '',
    text,
    title
}) => (
    <div className={styles.modalHeader}>
        {icon && (
            <div>
                <Icon
                    alt={iconAlt}
                    className={`${headerIconClassName} ${styles.icon}`}
                    image={icon}
                    id="headerIcon"
                />
            </div>
        )}

        <ModalHeaderTitle
            headerHeadingClassName={headerHeadingClassName}
            headerTextClassName={headerTextClassName}
            text={text}
            title={title}
        />
    </div>
);

export default ModalHeader;
